import type { ReactNode } from 'react';
import { useTracking } from 'react-tracking';
import loadable from '@loadable/component';

const GuestRegistrationModal = loadable(
  () => import(/* webpackPrefetch: true */ '@components/GuestRegistrationModal')
);

interface Props {
  setShowRawData: (value: boolean) => void;
  showRegoModal: boolean;
  rawData: ReactNode;
}

export const RawDataWithRegoModal = ({
  setShowRawData,
  showRegoModal,
  rawData,
}: Props) => {
  const { trackEvent } = useTracking({
    type: 'track',
    subject: 'inlineRegistration',
  });

  return (
    <>
      {showRegoModal ? (
        <GuestRegistrationModal
          canClose={true}
          onClose={() => {
            setShowRawData(false);
            trackEvent({
              modifier: 'log_in_sign_up',
              action: 'close',
            });
          }}
          onRegisterSuccess={() => {
            trackEvent({
              modifier: 'registration',
              action: 'success',
            });
          }}
          onLoginSuccess={() => {
            trackEvent({
              modifier: 'login',
              action: 'success',
            });
          }}
        />
      ) : (
        rawData
      )}
    </>
  );
};
